<template>
  <div class="il-refinance-adapter" :style="adapterStyle">
    <EnterPhoneNumberReFinance
      :error="error"
      @phone-changed="onPhoneNumberChanged"
      @submit="onPhoneNumberEntered" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Segment from '@/Segment';
import LoginApi from '@/api/LoginApi';
import anonymousSession from '@/anonymousSession';
import EnterPhoneNumberReFinance from './EnterPhoneNumberReFinance.vue';

export default {
  name: 'IlReFinanceStoryLibAdapter',
  components: {
    EnterPhoneNumberReFinance,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    analyticsPrefix: {
      type: String,
      default: '',
    },
    extraParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      phoneNumber: '',
      error: null,
      hasSentLink: false,
    };
  },
  created() {
    Segment.trackUserGot('pageViewed', { pageName: 'ReFinanceSignup' });
  },
  computed: {
    adapterStyle() {
      return {
        backgroundColor: this.widget.backgroundColor || 'transparent',
        width: '100%',
        height: '100%',
        borderRadius: `${this.widget.borderRadius || 0}px`,
      };
    },
  },
  methods: {
    ...mapMutations('signup', ['setPhoneNumber']),
    getLastFourDigits(phoneNumber) {
      return phoneNumber.slice(-4);
    },
    onPhoneNumberChanged(phoneNumber) {
      this.phoneNumber = phoneNumber;
    },
    async onPhoneNumberEntered(phoneNumber) {
      this.phoneNumber = phoneNumber;
      this.setPhoneNumber(phoneNumber);
      this.error = null;

      if (this.hasSentLink) {
        this.$emit('userInteraction', { eventName: 'nextPage' });
        return;
      }

      const phoneLast4Digits = this.getLastFourDigits(phoneNumber);
      const anonId = anonymousSession.getId();
      Segment.trackUserInteraction('ReFinanceSignup_PhoneNumberEntered', { phoneLast4Digits });

      try {
        await LoginApi.sendReFinanceLink(phoneNumber, anonId);
        this.hasSentLink = true;
        Segment.trackUserInteraction('ReFinanceSignup_LinkSent', { phoneLast4Digits });
        this.$emit('userInteraction', { eventName: 'nextPage' });
      } catch (e) {
        Segment.trackUserInteraction('ReFinanceSignup_LinkSendFailed', { phoneLast4Digits, error: e.message });
        this.error = 'אירעה שגיאה, נסה שוב';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.il-refinance-adapter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: transparent !important;
}
</style>
